import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { localizedZoneName } from './zone-name.pipe';

/**
 * Rend lisible un nom d'emplacement.
 *
 * Quand l'utilisateur n'a pas nommé sa zone, l'app y écrit le TYPE brut :
 * l'écran affichait alors « PLANTER_BOX » et « INDOOR » en capitales, au
 * milieu de phrases en français. Le catalogue `common.location-types` existait
 * déjà pour l'onboarding et le profil ; il sert enfin partout.
 *
 * Un nom choisi par l'utilisateur (« Serre du fond ») traverse le pipe sans
 * être touché : on ne traduit que ce qui est manifestement une valeur d'enum.
 *
 * Plusieurs emplacements peuvent arriver séparés par « · » : le serveur les
 * regroupe quand une même culture pousse à plusieurs endroits. L'écran les
 * sépare par une virgule, comme dans une phrase.
 */
@Pipe({ name: 'locationLabel', standalone: true, pure: false })
export class LocationLabelPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value
      .split('·')
      .map((part) => this.label(part.trim()))
      .join(', ');
  }

  /** Même règle que `vwZoneName` : un nom qui vaut un type d'enum est traduit, tout autre nom passe tel quel. */
  private label(name: string): string {
    return localizedZoneName({ name, locationType: name }, this.translate);
  }
}
